import { observable } from "mobx";

import { QuizObjectTable } from './quiz-object-table';

class QuizObjectTableColumn {
    @observable id: number | undefined = undefined;
    @observable title: string = '';
    @observable order: number | undefined = undefined;
    @observable valueType: string = 'string';
    @observable list: Array<string> = [];
    quizObjectTable: QuizObjectTable | undefined = undefined;

    constructor(quizObjectTable: QuizObjectTable, column?: any) {
        this.quizObjectTable = quizObjectTable;
        if (column) {
            if (column.valueType) {
                this.valueType = column.valueType;
            }
            this.title = column.title;
            if (column.order) {
                this.order = column.order;
            } else {
                this.order = quizObjectTable.getNextOrderValue();
            }
            this.list = column.list;
        } else {
            this.list = [''];
            this.order = quizObjectTable.getNextOrderValue();
        }
        if (!this.id) {
            this.id = this.quizObjectTable.getNextID();
        }
    }

    public removeRow(row: number) {
        this.list.splice(row, 1);
    }

    public addRow() {
        this.list.push('');
    }

    setValue(row: number, newValue: string) {
        this.list[row] = newValue;
    }

    toJSON() {
        return {
            id: this.id,
            title: this.title,
            list: this.list,
            order: this.order,
            valueType: this.valueType
        };
    }
    
    setTitle(title: string) {
        this.title = title;
    }
}

export {
    QuizObjectTableColumn
}